import { USER } from "../../constants";

const initState = {
  user: {},
  loading: true,
  isFirstLogin: false,
};

const userReducer = (state = initState, action) => {
  switch (action.type) {
    case USER.USER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case USER.USER_LOADED:
      return {
        ...state,
        loading: false,
      };

    case USER.USER_RESPONSE: {
      const responseUser = action.payload?.user || {};

      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          ...responseUser,

          /*
           * Якщо бекенд не повернув країну або дату народження,
           * очищаємо старі значення, які могли залишитися в Redux.
           */
          country: responseUser.country ?? "",
          date_birth: responseUser.date_birth ?? null,
        },
        isFirstLogin: Boolean(
          action.payload?.isFirstLogin,
        ),
      };
    }

    case USER.USER_FIELD:
      return {
        ...state,
        loading: false,
        user: {
          ...state.user,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};

export default userReducer;
